import React, { Component } from "react";

import QRCode from 'qrcode.react';

import { message, Button, Input } from 'antd';
import { Link } from 'react-router-dom';

import Config from "../../config/Config";
import WidgetAjax from "../../widget/WidgetAjax";
import WidgetTable from "../../widget/WidgetTable";
import WidgetModal from "../../widget/WidgetModal";

import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

let SystemType = Config.getSystemType();
class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            qrCodeImg: '',
            timer: null,
            ENTTYPE: '',
            qrCodeExpired: false, // 记录二维码是否失效
            modelOptions: {
                modalType: "form",
                title: '模拟登录',
                index: 0,
                width: '760px',
                message: null,
                isNext: false,
                isOk: true,
                wrapClassName: 'sg-index-model',
                okText: "关闭",
                bodyStyle: { padding: 0 },
            },
            isHide: true,
            columns: [
                { name: 'ZJ', title: '主键', type: 'string', description: '主键', properties: { hidden: true } },
                { name: 'UNISCID', title: '统一社会信用代码', type: 'string', description: '统一社会信用代码', properties: { hidden: true } },
                { name: 'ENTNAME', title: '模拟个体工商户名称', type: 'string', description: '模拟个体工商户名称', properties: { width: 220 } },
                { name: 'SBSTATE', title: '模拟申报状态', type: 'string', description: '模拟申报状态', properties: {} },
                {
                    name: "operation", title: "操作", type: "string", description: "操作", properties: {
                        operations: [
                            { name: "登录", click: "login" },
                        ]
                    },
                },
            ],
            tableOptions: {
                records: 10,
                check: false
            },
        }
    }
    componentDidMount() {
        this.getLoginToken()
    }
    componentWillUnmount() {
        clearInterval(this.timer)
    }
    getEntType() {
        let ENTTYPE = localStorage.getItem("ENTTYPE")
        if (ENTTYPE) {
            this.setState({
                ENTTYPE: ENTTYPE
            })
            this.getLoginToken()

        }
        else {
            message.warning('首次注册登录，请先查询申报资格');
        }

    }
    getLoginToken() {
        this.getQrCode()
    }
    getQrCode() {
        this.setState({ qrCodeExpired: false }); // 关闭蒙层
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/Qrcode/getQridUrl',
            params: undefined,
            callback: (data) => {
                if (data && data.status === 0) {
                    let qrinfo = JSON.parse(data.result.qrinfo)
                    this.setState({
                        qrCodeImg: `${process.env.NODE_ENV === 'development' ? data.result.jumpurl_test : data.result.jumpurl}${JSON.stringify(qrinfo)}`
                    })
                    // 设置定时器检查二维码失效
                    setTimeout(() => {
                        this.setState({ qrCodeExpired: true });
                        clearInterval(this.timer)
                    }, 300000); // 设置5分钟后二维码失效  
                    // 轮询查询扫码状态
                    // this.timer = setInterval(() => {
                    this.pollingGetQrState(data.result.qrid)
                    // }, 5000)
                }
            }
        }, this);
    }
    pollingGetQrState(qrid) {
        const { qrCodeExpired } = this.state;
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/Qrcode/getQrState',
            params: { qrid },
            callback: (data) => {
                // 延迟5秒后执行
                setTimeout(() => {
                    if (data && data.message_header && data.message_header.errorInfo && data.message_header.errorInfo === '等待授权' && qrCodeExpired != true) {
                        this.pollingGetQrState(qrid);
                    }
                }, 5000);

                if (data && typeof data === 'string') {
                    data = JSON.parse(data.replace(/[\n\r\r\n\t\\]+/g, ""))
                }
                if (SystemType === 'sso') {

                    if (data && data.message_content && data.message_content.type && data.message_content.type != null) {

                        if (data.message_content.type === '8' ||  data.message_content.uniscid === '91110112MA7HCNREXC') {

                            if (data.message_header.errorCode === 0 || data.message_header.errorCode === '0') {


                                const originalData = data.message_content;
                                // 使用 reduce 方法创建一个新对象
                                const cleanedData = Object.keys(originalData).reduce((acc, key) => {
                                    const value = originalData[key];
                                    // 如果是字符串，则进行处理
                                    acc[key] = typeof value === 'string' ? value.replace(/"/g, '“') : value;
                                    return acc;
                                }, {});
                                sessionStorage.setItem("_user_info_", JSON.stringify(cleanedData));

                                // sessionStorage.setItem("_user_info_", JSON.stringify(data.message_content))
                                if (data.user_info && data.user_info.access) {
                                    sessionStorage.setItem("_user_access_", data.user_info.access)
                                }
                                this.queryAuditMaxnewinfo()
                            }

                        } else {
                            clearInterval(this.timer);
                            this.getQrCode.bind(this);
                            this.onModalRef.open();
                            return
                        }
                    }

                } else {
                    if (data.message_header.errorCode === 0 || data.message_header.errorCode === '0') {

                        const originalData = data.message_content;
                        // 使用 reduce 方法创建一个新对象
                        const cleanedData = Object.keys(originalData).reduce((acc, key) => {
                            const value = originalData[key];
                            // 如果是字符串，则进行处理
                            acc[key] = typeof value === 'string' ? value.replace(/"/g, '“') : value;
                            return acc;
                        }, {});
                        sessionStorage.setItem("_user_info_", JSON.stringify(cleanedData));

                        // sessionStorage.setItem("_user_info_", JSON.stringify(data.message_content))
                        if (data.user_info && data.user_info.access) {
                            sessionStorage.setItem("_user_access_", data.user_info.access)
                        }
                        this.queryAuditMaxnewinfo()
                    }
                }


            }
        }, this);
    }

    goPage() {
        this.props.history.replace({ pathname: "/home/index", state: {} });
        window.location.reload()
    };
    queryAuditMaxnewinfo() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/audit_maxnewinfo',
            params: {},
            callback: (data) => {
                if (data && data.status === 0) {
                    if (data.result) {
                        if (data.result.PROVINCE && data.result.CITY && data.result.COUNTY) {
                            let arr = [data.result.PROVINCE, data.result.CITY, data.result.COUNTY]
                            let arrStr = [data.result.PROVINCESTR, data.result.CITYSTR, data.result.COUNTYSTR]
                            localStorage.setItem('defaultValue', arr.join(','))
                            localStorage.setItem('ProvincialUrbanAreas', arrStr.join(','))
                            localStorage.setItem('region', data.result.COUNTYSTR)
                        }
                    }
                    this.goPage()
                }
            }
        }, this);
    }
    goDetail() {
        this.props.history.push({ pathname: "/home/detail", state: {} });
    }
    goUpPage() {
        window.history.go(-1);
    }

    /**
     * 把子组件注入到父主键里
     * @param {*} ref 
     */
    onRef = (ref) => {
        this.modal = ref;
    };

    analog = () => {

        this.setState({
            data: [],
            username: null
        });

        this.modal.open();
    }

    queryList = () => {
        const { username, } = this.state;

        if (username && username !== "") {

            const onQueryList = (result, params) => {

                if (result.status === 0) {
                    this.setState({
                        data: result.results,
                    });
                }
                else {
                    message.error(result.message);
                }
            }

            let params = {
                SPUSERNAME: username,
                page: 1,
                records: 5
            }

            WidgetAjax.ajax({ url: Config.getBasePath() + '/entsq/analog_list', params: params, callback: onQueryList });

        }
        else {
            message.warning('请输入您的审批系统账号！');
        }
    }

    notify = (type, data, value, index, event, val) => {

        switch (type) {
            case "login":
                {
                    this.analogLogin(data);
                    break;
                }
        }
    }

    analogLogin = (item) => {

        const onAnalogLogin = (result, params) => {
            if (result) {
                if (result && typeof result === 'string') {
                    result = JSON.parse(result.replace(/\n|\r|\r\n|\t+/g, ""))
                }
                sessionStorage.setItem("_user_info_", JSON.stringify(result.message_content));
                if (result.user_info && result.user_info.access) {
                    sessionStorage.setItem("_user_access_", result.user_info.access)
                }
                this.queryAuditMaxnewinfo()
            }
            else {
                message.error(result.message);
            }

        }

        let params = {
            uniscid: item.UNISCID
        }

        WidgetAjax.ajax({ url: Config.getBasePath() + '/Qrcode/analog_login', params: params, callback: onAnalogLogin });
    }

    onKeyUp = (e) => {

        if (e.keyCode === 13) {
            this.queryList();
        }
    }

    render() {
        const { qrCodeImg, qrCodeExpired, modelOptions, isHide, username, data = [], columns, tableOptions } = this.state;
        return (
            <div data-component="login">
                <div className="sg-login">
                    <div className="sd-start">
                        <div onClick={() => { this.goUpPage() }}>
                            <img className='sg-title-img1' alt='#' src={require('../../img/business/upPage.png')} />
                            <span className="sg-top-font">返回</span>
                        </div>
                    </div>

                    <div className="sg-login-center">
                        <div className="sg-left-login">
                            <div className="sg-leftTop-login sd-middle">电子营业执照使用说明</div>
                            <div className="sg-leftCenter-login">
                                <div>1、请使用<span className="sg-fonts-login">微信 / 支付宝 / 电子营业执照APP扫码登录</span></div>
                                <div>2、选择电子营业执照，输入个体工商户名称、统一社会信用代码等信息进行验证。</div>
                                <div>3、验证通过后，点击“确认登录”，即可登录名特优新申报系统。</div>
                            </div>
                            <div className="sg-leftBottom-login"><div>没有电子营业执照，怎么办？</div><div> </div><div> </div><div className="sg-guide-login" onClick={() => { this.goDetail() }}>查看操作指南</div></div>
                        </div>
                        <div className="sg-center-login"></div>
                        <div className="sg-right-login">
                            <div className="sg-rightTop-login sd-middle">电子营业执照登录</div>

                            <div className="sg-rightCenter-login sd-middle" style={{ border: '1px solid rgba(26, 72, 125, 0.15)' }}>
                                {/* 根据二维码是否失效显示蒙版提示 */}
                                {qrCodeExpired ? (
                                    <div className="sg-qr-expired-mask">
                                        <img className='sg-qr-expired-icon' alt='#' src={require('../../img/login/info.png')} />
                                        <div className="sg-qr-expired-message">二维码已失效</div>
                                        <button className="sg-qr-refresh-button" onClick={this.getQrCode.bind(this)}>点击刷新</button>
                                    </div>
                                ) : null}
                                <QRCode value={qrCodeImg} size={200} fgColor="#000000" id="qrCode"></QRCode>

                            </div>
                            {
                                SystemType != 'sso' ?
                                    <div className="sf-analog">
                                        <Button type="primary" style={{ marginTop: '20px' }} block size="large" onClick={this.analog}>模拟登录</Button>
                                        <div className="sg-login-tip">（仅在模拟环境中使用）</div>
                                    </div> : <></>
                            }

                        </div>
                    </div>
                </div>

                <WidgetModal options={modelOptions} onRef={this.onRef} isHide={isHide}>
                    <div className="sg-modal-login sf-padding">
                        <div className="sg-center-middle sg-filter">
                            <div className="sg-middle-list sd-middle">
                                <Input placeholder="请输入您的审批系统帐号" bordered={false} value={username} onKeyUp={this.onKeyUp} onChange={(e) => this.setState({ username: e.target.value })} />
                            </div>
                            <div className="sg-middle-bottom">
                                <Button type="primary" style={{ marginTop: '0px' }} block size="large" onClick={this.queryList}> 获取登录信息</Button>
                            </div>
                        </div>

                        <div className="sg-contet">
                            {
                                data && data.length > 0 ? <div>
                                    <WidgetTable columns={columns} options={tableOptions}
                                        data={data} total={data.length} notify={(e, i) => { this.notify(e, i) }} check={false} isFooter={false} />
                                </div>
                                    :
                                    <>
                                        <div className="sg-tip">操作步骤:</div>
                                        <div className="sg-tip">第1步:输入您在审批系统中开通的账号</div>
                                        <div className="sg-tip">第2步:点击“获取登录信息”按钮，系统会自动分配给您5个模拟的个体工商户信息</div>
                                        <div className="sg-tip">第3步:选择其中一个模拟个体工商户进行登录</div>
                                    </>
                            }
                        </div>




                    </div>
                </WidgetModal>

                <WidgetModal options={{ title: '提示', okText: '我知道了', wrapClassName: 'isNotIndividual', isCancel: false }} onRef={ref => this.onModalRef = ref} >
                    <div style={{ textAlign: "center", display: 'grid' }}>
                        <text >您当前使用的电子营业执照类型不是个体工商户，</text>
                        <text >不符合平台登录填报的资格要求。</text>
                        <text>如有问题，请咨询当地主管单位！</text>
                    </div>
                </WidgetModal>
            </div>
        )
    }
}

export default Index
